import React, { useEffect, useState } from "react";
import { images } from "../../config/images";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import Aos from "aos";
import "../Blog/Blog.css";
import { Box, Grid, Pagination, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { blog } from "../../config/services";
import { slugify } from "../../utils/slugify";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";

const CustomPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    borderColor: "var(--accent-color)",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: "30px",
  },
  "& .Mui-selected": {
    borderColor: "var(--accent-color)",
    backgroundColor: "var(--accent-color)  !important",
    color: "var(--white)",
  },
}));

const Blog = ({ settingAPIData, headerAPIData }) => {
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [blogAPIData, setBlogAPIData] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  const isPDF = (url) => url?.toLowerCase().endsWith(".pdf");

  useEffect(() => {
    handleblog();
  }, [currentPage]);

  const handleblog = async () => {
    try {
      setIsLoading(true);
      const resp = await blog(currentPage, perPage);
      if (resp.data.code === 200 || resp.data.code === 201) {
        setIsLoading(false);
        setBlogAPIData(resp.data.responseBody);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("handlesubmit", error);
    }
  };

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  const breadcrumbsData = [
    { label: "Home", url: "/" },
    {
      label: "Blog",
      url: "/blog",
    },
  ];
  useEffect(() => {
    Aos.init({ duration: 2400 });
  }, []);
  const itemsPerPage = 3;

  const navigate = useNavigate();

  return (blogAPIData && headerAPIData)?.length === 0 ? (
    <FullpageLoader />
  ) : (
    <>
      <div className="">
        <div className="about-us-container">
          <div className="molecule left">
            <img
              src={images.leftSpirrel}
              alt="Left Molecule"
              className="left-spinner"
            />
          </div>
          <div className="about-text">
            <h1>Blog</h1>
            <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
          </div>
          <div className="molecule right">
            <img
              src={images.rightSpirrel}
              alt="Right Molecule"
              className="right-spinner"
            />
          </div>
        </div>
        <div className="blog-listing-sec">
          <h2 className="blog-listing-title">Our Latest Blogs & News</h2>
          <div className="common-sec">
            <Grid container spacing={3}>
              {isLoading
                ? Array.from({ length: 3 }).map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={`shimmer-${index}`}>
                      <Box className="home-blog-card blog-page-card shimmer-card">
                        <div className="home-blog-card-icon-wrap">
                          <div className="shimmer-img" />
                        </div>
                        <div className="blog-card-body">
                          <div className="home-blog-card-meta">
                            <div className="shimmer-contact-icon" />
                            <span className="shimmer-text" style={{ width: "80px" }} />
                            <span className="home-blog-card-meta-sep" />
                            <div className="shimmer-contact-icon" />
                            <span className="shimmer-text" style={{ width: "70px" }} />
                          </div>
                          <div className="shimmer-text shimmer-title" style={{ marginBottom: "16px" }} />
                          <div className="shimmer-button" style={{ width: "120px", height: "40px", borderRadius: "8px" }} />
                        </div>
                      </Box>
                    </Grid>
                  ))
                : blogAPIData?.data?.map((e) => (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={e.id}>
                      <Box className="home-blog-card blog-page-card">
                        <div className="home-blog-card-icon-wrap">
                          {isPDF(e.image) ? (
                            <img src={e.cover_image || images.pdfImg} alt={e.title || "Blog"} />
                          ) : (
                            <img src={e.image} alt={e.title || "Blog"} />
                          )}
                        </div>
                        <div className="blog-card-body">
                          <div className="home-blog-card-meta">
                            <span className="home-blog-card-meta-item">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                              {e.author_name}
                            </span>
                            <span className="home-blog-card-meta-sep" aria-hidden="true" />
                            <span className="home-blog-card-meta-item">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                              {new Date(e.date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                            </span>
                          </div>
                          <h3 className="blog-card-title">{e.title}</h3>
                          <button
                            type="button"
                            className="home-blog-card-btn"
                            onClick={() => navigate(`/blog/${slugify(e.title)}`, { state: { blogId: e.id } })}
                          >
                            Read More <span className="home-blog-card-btn-arrow">→</span>
                          </button>
                        </div>
                      </Box>
                    </Grid>
                  ))}
            </Grid>

            <Stack spacing={2} className="blog-pagination-wrap">
              <CustomPagination
                count={Math.ceil(blogAPIData?.total / blogAPIData?.per_page) || 1}
                page={currentPage}
                onChange={handleChange}
                siblingCount={1}
                boundaryCount={4}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
